/**
* Renders a pulsing placeholder table imitating leaderboard content while data loads.
* @example
* LeaderboardSkeleton()
* <div className="animate-pulse">…</div>
* @param {void} _ - No parameters.
* @returns {JSX.Element} A skeleton leaderboard table markup.
**/
const LeaderboardSkeleton = () => {
  return (
    <div className="animate-pulse">
      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-border-primary rounded-lg overflow-hidden border border-border-primary">
          <thead className="bg-background-secondary">
            <tr>
              {[1, 2, 3, 4, 5].map((i) => (
                <th key={i} className="px-4 py-3">
                  <div className="h-4 bg-background-tertiary rounded w-20" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-border-primary bg-background-primary">
            {[1, 2, 3, 4, 5].map((i) => (
              <tr key={i}>
                <td className="px-4 py-3">
                  <div className="size-6 bg-background-tertiary rounded-full" />
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <div className="size-8 bg-background-tertiary rounded-full" />
                    <div className="h-4 bg-background-tertiary rounded w-24" />
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 bg-background-tertiary rounded w-12" />
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 bg-background-tertiary rounded w-12" />
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <div className="w-16 h-2.5 bg-background-tertiary rounded-full" />
                    <div className="h-4 bg-background-tertiary rounded w-8" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeaderboardSkeleton;
